module.exports = __webpack_public_path__ + "img/certImg1.b1f88599.png";